module.exports = __webpack_public_path__ + "img/Sword_Stormbringer_00_FREE.c9e9b1b4.png";